/**
 * Beschriftungen und Textauszüge der Wissensdatenbank — geteilt von Liste und Artikelseite.
 */
import type { KnowledgeBaseArticle } from '../../lib/api/domains/knowledgeBase';

type KbStatus = KnowledgeBaseArticle['status'];

export const KB_STATUS_LABEL: Record<KbStatus, string> = {
  DRAFT: 'Entwurf',
  PENDING_APPROVAL: 'Wartet auf Freigabe',
  PUBLISHED: 'Veröffentlicht',
  REJECTED: 'Abgelehnt',
};

export const KB_STATUS_COLOR: Record<KbStatus, string> = {
  DRAFT: 'gray',
  PENDING_APPROVAL: 'yellow',
  PUBLISHED: 'green',
  REJECTED: 'red',
};

export const KB_CATEGORIES = [
  'Hardware Setup',
  'Software Issues',
  'Netzwerk',
  'Mobil',
  'Fehlerdiagnose',
  'Best Practices',
  'Sonstiges',
];

/** Mindestlängen des Servers (routes/knowledgeBase.ts) — hier, damit der Hinweis vor dem Speichern kommt. */
export const KB_MIN_TITLE = 5;
export const KB_MIN_CONTENT = 50;

/** Markdown grob zu Fließtext, für die Vorschau in Listen. */
export function kbPlainSnippet(markdown: string, max = 220): string {
  const text = markdown
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^\s{0,3}(#{1,6}|>|[-*+]|\d+\.)\s+/gm, '')
    .replace(/[*_`~|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > max ? `${text.slice(0, max).trimEnd()} …` : text;
}

export function kbFormatDate(value: string | null | undefined): string {
  if (!value) return '';
  return new Date(value).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
